interface IconProps {
  size?: number;
  width?: number;
  height?: number;
  fill?: string;
}

export const EuroIcon = ({
  size = 24,
  width,
  height,
  fill = "#0F8FF8",
  ...props
}: IconProps) => {
  return (
    <svg
      width={width || size}
      height={height || size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 14.253L6.6075 12.75H7.25025C7.2336 12.4928 7.2251 12.2352 7.22475 11.9775C7.22475 11.6415 7.239 11.3295 7.26675 11.04H6L6.6075 9.53775H7.563C8.4525 6.6795 10.458 5.25 13.5773 5.25C14.6025 5.25 15.5767 5.38275 16.5 5.649V7.542C15.6311 7.15374 14.6894 6.95532 13.7377 6.96C11.868 6.96 10.6658 7.8195 10.1302 9.5385H15.6975L15.09 11.0408H9.76725C9.73538 11.2882 9.72134 11.5376 9.72525 11.787C9.72525 12.1463 9.7365 12.4673 9.759 12.7508H14.3962L13.7963 14.253H10.08C10.4797 15.2948 10.9672 16.0192 11.5417 16.428C12.1155 16.836 12.9353 17.04 13.9995 17.04C14.76 17.04 15.5933 16.8548 16.5 16.4843V18.264C15.6383 18.588 14.6137 18.75 13.425 18.75C10.2997 18.75 8.32275 17.2508 7.4955 14.253H6Z"
        fill="white"
      />
    </svg>
  );
};

export default EuroIcon;
